<!--
    描述：本次签署信息
    日期：2022/06/24
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          业务流水号：{{formObj.bizNumber}}
        </el-col>
        <el-col :span="12">
          流程发起时间：{{formObj.createDate}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          业务来源：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          本次签署状态：
          <span v-if="formObj.flowState == 2">成功</span>
          <span v-if="formObj.flowState == 3">失败</span>
          <span v-if="formObj.flowState == 4">拒签</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          发起人账户ID：{{formObj.accountId}}
        </el-col>
        <el-col :span="12">
          发起人姓名：{{formObj.createUserName}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          发起人主体类型：
        </el-col>
        <el-col :span="12">
          发起人证件类型：{{formObj.userCertType}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          发起人证件号：{{formObj.userCertNo}}
        </el-col>
        <el-col :span="12">
          签署方类型：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          签署人签署完成回调地址：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          本次签署流程的基本信息：
        </el-col>
        <el-col :span="12">
          本次签署流程的文件主题名称：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          本次签署流程的截止时间：
        </el-col>
        <el-col :span="12">
          本次签署文件的到期时间：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          全部签章后流程：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          业务码（code)：
        </el-col>
        <el-col :span="12">
          业务信息：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          业务数据：
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import * as API from 'api/modules/es/es_order.js'
export default {
  name : 'detail_tab_csi',
  components: {

  },
  data() {
    return {
      formObj : {

      },
    }
  },
  mounted() {},
  computed: {
    orderId() {
      return this.$route.query.id
    },
  },
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {
    this.getObjectById()
  },
  methods: {
    getObjectById(){
      API.getObjectById({id: this.orderId}).then(res=>{
        if(res.operationCode == 1) {
          this.formObj = res.data
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.tab-main-page{
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>